// extracted by mini-css-extract-plugin
module.exports = {"About":"About_About__ab3bl","info":"About_info__31xyU"};